export default "__VITE_ASSET__CrCiaGQ3__"